module.exports = __webpack_public_path__ + "static/media/share_person2.2108e680.png";